import { render, staticRenderFns } from "./ArtRequest.vue?vue&type=template&id=0e2cabc8&scoped=true&"
import script from "./ArtRequest.vue?vue&type=script&lang=js&"
export * from "./ArtRequest.vue?vue&type=script&lang=js&"
import style0 from "./ArtRequest.vue?vue&type=style&index=0&id=0e2cabc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2cabc8",
  null
  
)

export default component.exports